import React, { useEffect, useRef } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import * as actions from './actions'
import { useParams, Link } from 'react-router-dom'
import { InitialState } from './types'

// Components
import Header from '../../components/Header'
import Footer from '../../components/Footer'
import LoadingPage from '../../components/LoadingPage'

export default () => {
  const dispatch = useDispatch()
  const isMounted = useRef<boolean>(false)
  const { id } = useParams<{ id: string }>()

  const { lessons, isProcessFetching, error } = useSelector(
    (state: { adminLessonsList: InitialState }) => state.adminLessonsList
  )

  useEffect(() => {
    dispatch(actions.destroy())
    dispatch(actions.fetchLessonsList(id))
    isMounted.current = true
    return () => {
      dispatch(actions.destroy())
    }
  }, [])

  const handleRemoveLesson = (lessonId: string) => {
    dispatch(actions.removeLesson(id, lessonId))
  }

  return (
    <>
      <Header />
      <div className={'container'}>
        {!isMounted.current || isProcessFetching ? (
          <LoadingPage />
        ) : (
          <>
            <h2>Панель администрирования - Список уроков</h2>
            <Link to={`/admin/courses/${id}/lessons/create`}>
              <button>Создать урок</button>
            </Link>
            {lessons && lessons.length ? (
              <table style={{ width: '100%', marginBottom: 40, marginTop: 15 }}>
                <thead>
                  <tr>
                    <td>
                      <b>Название урока</b>
                    </td>
                    <td></td>
                    <td></td>
                  </tr>
                </thead>
                <tbody>
                  {lessons.map(lesson => (
                    <tr key={lesson.lesson_id}>
                      <td>{lesson.title}</td>
                      <td style={{ textAlign: 'center' }}>
                        <Link
                          to={`/admin/courses/${id}/lessons/${lesson.lesson_id}`}
                        >
                          <button>Изменить</button>
                        </Link>
                      </td>
                      <td style={{ textAlign: 'center' }}>
                        <button
                          onClick={() => handleRemoveLesson(lesson.lesson_id)}
                          style={{ color: '#FFF', background: 'red' }}
                        >
                          X
                        </button>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            ) : (
              <h3>Нет созданных уроков!</h3>
            )}
          </>
        )}
        {error ? <span style={{ color: 'red' }}>{error}</span> : null}
      </div>
      <Footer />
    </>
  )
}
